import React from "react"
import s from "./Background.less"

interface iBackgroundProps {
  url: string
  className?: string
}

const Background: React.FC<iBackgroundProps> = ({ url, className }) => {
  return (
    <div
      className={`${s.root} ${className}`}
      style={{ backgroundImage: `url(${url})` }}
    ></div>
  )
}

export default Background
